import apiClient from 'apiClient';
import { AxiosResponse } from 'axios';

interface Response extends AxiosResponse<any> {}

export class GenerateOfferPackError extends Error {
  private errors: string[];

  constructor(message: string, errors: string[]) {
    super(message);
    this.errors = errors;
  }

  getErrors() {
    return this.errors;
  }
}

const generateOfferPack = (endpoint: string) => async (): Promise<Response['data']> => {
  try {
    const response = await apiClient.post<any, Response>(`${endpoint}/generate-offer-pack`, {});
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 400) {
        let errors = [];
        if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
          errors = error.response.data.errors;
        } else if (error.response.data.details) {
          errors = [error.response.data.details];
        }
        throw new GenerateOfferPackError('GenerateOfferPackError', errors);
      }
    }
    throw error;
  }
};

export default generateOfferPack;
